/**
 * Ryan O'Dowd
 * 2024-11-11
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const PopoverInner = (props: PopoverInnerProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      {props.children}
    </View>
  );
};

class PopoverInnerProps {
  children: React.ReactNode;
};

export default PopoverInner;
